import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { TokenService } from '../../_services/token.service';
import { WeatherService } from '../../_services/weather.service';
import { Weather } from '../../_models/ForecastDay';
import { BERLIN_COORDINATES } from 'src/app/upload/Utils/Constant';
import {MERCK_TENANT} from "../../_helpers/Constants";

@Component({
  selector: 'app-weather-widget',
  templateUrl: './weather-widget.component.html',
  styleUrls: ['./weather-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WeatherWidgetComponent {
  weather: Weather | undefined;
  @Output() isLoading = new EventEmitter<boolean>(true);
  constructor(
    private tokenService: TokenService,
    private weatherService: WeatherService
  ) {
    this.isLoading.emit(true);
    const location = this.tokenService.getTenantLocation();
    const isHaveTwoLocations =
      !!location &&
      typeof location === 'string' &&
      Array.isArray(location.split(',')) &&
      location.split(',').length === 2;
    this.weatherService
      .GetWeather(!isHaveTwoLocations ? BERLIN_COORDINATES : location)
      .subscribe((data) => {
        this.weather = data;
        this.isLoading.emit(false);
      });
  }

  getDayName(date: string) {
    const toDate = new Date(date);
    return toDate.toLocaleDateString('de-DE', { weekday: 'long' });
  }

  get isMerckTenant(): boolean {
    return this.tokenService.GetTenant() === MERCK_TENANT;
  }
}
